import registrationTypesApi from '@/api/registrationTypes'

export const SET_REGISTRATION_TYPES = 'SET_REGISTRATION_TYPES'
export const CLEAR_REGISTRATION_TYPES = 'CLEAR_REGISTRATION_TYPES'

const state = {
  registrationTypes: []
}
const getters = {
  getterRegistrationTypes: state => state.registrationTypes
}
const mutations = {
  [SET_REGISTRATION_TYPES] (state, values) {
    state.registrationTypes = values
  },
  [CLEAR_REGISTRATION_TYPES] (state) {
    state.registrationTypes = []
  }
}
const actions = {
  actionGetTypes ({ commit }) {
    return registrationTypesApi.getTypes()
      .then((response) => {
        commit(SET_REGISTRATION_TYPES, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
